///////////////////////////////////////////////////////////////////////////////////
// Containers to hold global lookups, variables and configuration
///////////////////////////////////////////////////////////////////////////////////
const CONFIG = {};
const LOOKUP = {};
const DATA = {};

///////////////////////////////////////////////////////////////////////////////////
// Styles, in production, these will be written to <script> tags
///////////////////////////////////////////////////////////////////////////////////
import styles from './index.scss';

///////////////////////////////////////////////////////////////////////////////////
// Global configuration
///////////////////////////////////////////////////////////////////////////////////

// initial map width and height
CONFIG.mapwidth  = styles.mapwidth;
CONFIG.mapheight = styles.mapheight;

// responsive bar chart width and nav breakpoint
// must match css media-queries in index.css
CONFIG.collapse_breakpoint = styles.collapse_breakpoint;

// by default, redraw everthing on a window resize. There are cases however, where redraw is unnecessary, and leads to problems, like restacking of bars in the barchart where there are tied values
CONFIG.redraw = true;

// String formatting functions
CONFIG.format = {
  // what are 2018 vs. 2020 dollars??
  "2018dollars": function(n) {
    return "$" + parseFloat(n).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 0})
  },
  "2019dollars": function(n) {
    return "$" + parseFloat(n).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 0})
  },
  "2020dollars": function(n) {
    return "$" + parseFloat(n).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 0})
  },
  "number": function(n) {
    return parseFloat(n).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 0})
  },
  "percent": function(n) {
    return parseFloat(n).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 0}) + "%"; 
  },
  "none": function(n) {return n},
  "string": function(n) {return n},
};

// placeholder for indicator lookup; each time indicator changes, this lookup is constructed for all county values for this indicator
CONFIG.ind_lookup = {}; 

// Context specific constants: the current state name, as present in the data, and the number of counties
CONFIG.statename = "newjersey";
CONFIG.county_count = 21;
CONFIG.university_count = 12;

// hover and click styles for counties and circles
CONFIG.hovered_place_color = "#d67159";
CONFIG.selected_place_color = "#d04b18";

// which colorscheme to use?
// see https://github.com/d3/d3-scale-chromatic
// CONFIG.colorscheme = "interpolateViridis";
CONFIG.colorscheme = "interpolateGnBu";
CONFIG.deafult_opacity = styles.default_opacity;
CONFIG.ethnicity_bar_color = "#a7d2ef";

// bar units: county and university barchart width
CONFIG.county_barchart_width = +styles.county_barchart_width;
CONFIG.university_barchart_width = +styles.university_barchart_width;
// bar units: individual bar height for counties, university data, ethnicity data
CONFIG.county_bar_height = +styles.county_bar_height;
CONFIG.university_bar_height = +styles.university_bar_height;
CONFIG.ethnicity_bar_height = +styles.ethnicity_bar_height;

// these two indicators get special treatment
CONFIG.university_indicators = ["percentgradsdebt", "avgstudentdebt"];
// placeholder to track if we are looking at a "university" indicator, or not
CONFIG.university = false;

// these two indicators get special handling on the race/eth chart
CONFIG.police_use_of_force_indicators = ["useofforcetotals", "useofforceperthousandarrests"];

// size of the University circles on the map
CONFIG.university_circle_radius = +styles.university_circle_radius;

////////////////////////////////////////////////////////////////////////
// INITIALIZATION: these functions are called when the page is ready,
////////////////////////////////////////////////////////////////////////
$(document).ready(function() {

  // data initialization first, then the remaining init steps
  Promise.all([
      initData("./data/data.csv?v=1.1"), 
      initData("./data/ethnicity.csv?v=1.1"),
      initData("./data/lookup.csv?v=1.1"),
      initData("./data/counties.json"), 
    ]).then(function(data) {

      initDataFormat(data);    // get data ready for use in the app
      initD3();                // sets up D3 variables and functions

      initNav();               // some additional behavior on the BS nav
      initButtons();           // init various buttons


    // set the active indicator to the first dimension indicator
    // and start the app by triggering a resize
    CONFIG.active_ind = DATA.dimensions[0].values[0]; 
    resize();

console.log(DATA);
console.log(CONFIG);


    }); // Promise.then()
});

//////////////////////////////////////////////////////////
// resize functions
//////////////////////////////////////////////////////////
$(window).resize(debounce(function() {
  resize();
}, 250));

function resize() {
  // update the county bar width for this screen width
  if (CONFIG.redraw) {
    redraw(CONFIG.active_ind);
  } else {
    CONFIG.redraw = true;
  }
}

//////////////////////////////////////////////////////////
// Init functions
//////////////////////////////////////////////////////////

// Generic asynchronous data init: returns a promise
function initData(url) {
  // wrap this in a promise, so we know we have it before continuing on to remaining initialize steps
  return new Promise(function(resolve, reject) {
    $.get(url, function(data) {
      resolve(data);
    });
  });
}

// data parsing and formatting, once all data are on-board
function initDataFormat(data) {
  // parse data from CSV to arrays of objects
  DATA.county_data = Papa.parse(data[0], {header: true}).data;
  DATA.ethnicity = []; // see below
  DATA.ethnicity_colleges = []; // see below
  let rawlookup = Papa.parse(data[2], {header: true}).data;

  // add formatted data to DATA; also format Margin of Error
  DATA.county_data.forEach(function(d) {
    d.rank = +d.rank;
    d.value = +d.value;
    d.formatted = isNaN(d.value) ? "Not Provided" : CONFIG.format[d.datatype](d.value);
    
    d.cilow_formatted = CONFIG.format[d.datatype](d.cilow);
    d.cihigh_formatted = CONFIG.format[d.datatype](d.cihigh);
  });

  // another pass, to grab the state data for the table
  let nj_data = DATA.county_data.filter(function(d) {
    return d.geography == 'newjersey';
  });
  DATA.nj_data = JSON.parse(JSON.stringify(nj_data));

  DATA.county_data.forEach(function(d) {
    d.state_value = DATA.nj_data.filter(function(i) { return d.indicator == i.indicator})[0];
  });

  // create DATA.ethnicity and DATA.ethnicity_colleges from raw data
  Papa.parse(data[1], {header: true}).data.forEach(function(d) {
      d.value = +d.value;
      d.formatted = d.formatted = isNaN(d.value) ? "Not Provided" : CONFIG.format[d.datatype](d.value);
      if (d.geography) {
        DATA.ethnicity_colleges.push(d);
      } else {
        DATA.ethnicity.push(d);
      }
    });

  // set up the university data
  let universityraw = rawlookup.filter(function(d) {
    return d.type == 'university'
  });
  DATA.universities = [];
  universityraw.forEach(function(d) {
    let latlong = d.notes.split(',');
    DATA.universities.push({
      'Name': d.long_title,
      'short_name': d.short_title,
      'lat': parseFloat(latlong[0]),
      'lon': parseFloat(latlong[1]),
      'geography': d.key,
    });
  })

  // set up the LOOKUP from data/lookup.csv
  rawlookup.forEach(function(d) {
    LOOKUP[d.key] = d;
  });

  // create DATA.dimensions from data/data.csv: All data nested by dimension > indicator > values for 58 counties + california
  DATA.dimensions = d3.nest()
    .key(function(d) { return d.dimension; })
    // TODO: no "order" defined yet in data sheet
    // .sortKeys(function(a,b){
    //   return CONFIG.dimension_order.indexOf(a) - CONFIG.dimension_order.indexOf(b);
    // })
    .key(function(d) { return d.indicator; })
    // sort the indicators alpabetically
    .sortKeys(function (a, b) {
      return d3.ascending(LOOKUP[a]["short_title"], LOOKUP[b]["short_title"]);
    })
    .entries(DATA.county_data);

  // keep a global reference to the county topojson
  DATA.county_topojson = data[3];

}

// set up D3 objects and containers for the map and charts
function initD3() {

  //
  // Map setup
  // 

  // 1) append an SVG container for the map
  let svg = d3.select("#map-div")
    .append("svg")
      .style("max-width", CONFIG.mapwidth)
      .style("max-height", CONFIG.mapheight)
      .attr("max-width", CONFIG.mapwidth)
      .attr("max-height", CONFIG.mapheight)
      .attr("class", "map");


  // 2) define the projection using the awesome fitSize()
  CONFIG.projection = d3.geoAlbers()
    .fitSize([CONFIG.mapwidth, CONFIG.mapheight], topojson.feature(DATA.county_topojson, DATA.county_topojson.objects.counties));

  // 3) set an SVG path with this projection
  let path = d3.geoPath()
    .projection(CONFIG.projection);

  // 4) add the county map from topojson
  d3.select("svg.map")
    // add a view box so dynamic scaling of one dimension preserves aspect ratio, see resize()
    .attr("preserveAspectRatio", "xMidYMid")
    .attr("viewBox", "0 0 " + CONFIG.mapwidth + " " + CONFIG.mapheight)
    .append("g")
    .attr("class", "counties")
    .selectAll("path")
    .data(topojson.feature(DATA.county_topojson, DATA.county_topojson.objects.counties).features)
    .enter().append("path")
    .attr("d", path)
    // start with white map and fade into color once we have data
    .style("fill", function(d,i) { return "#fff"; });


  //
  // Chart setup
  // 

  // append the county barchart
  var county_barchart = d3.select("div#chart-wrapper div#chart").append("div")
    .attr("class", "county-list");

  // append a div and title for the Ethnicity barchart, below the map div
  var eth_wrapper = d3.select("div#ethnicity-wrapper")
  eth_wrapper.append("h3")
    .attr("class", "ethchart-title")
    .text("Statewide by Race and Ethnicity");
  
  // append the ethnicity bar chart itself
  var ethnicity_barchart = eth_wrapper.append("div")
    .attr("class", "ethnicity-list");

  // append a div for enthnicity "no data" message, see update_ethnicity_barchart()
  eth_wrapper.append("div").text("Data not available by race and ethnicity for this indicator.")
    .attr("id","ethnicity-message")
    .style("display",null);

  // append the "plumb-lines": the vertical line that marks California wide values on the bar chart for the selected variable
  county_barchart.append("div")
    .attr("class", "plumb-line")
    .style("left", "20px");

  county_barchart.append("div")
    .attr("class", "plumb-label")
    .style("left", "20px");

  ethnicity_barchart.append("div")
    .attr("class", "plumb-line")
    .style("left", "20px");

  ethnicity_barchart.append("div")
    .attr("class", "plumb-label")
    .style("left", "20px");
}


function initButtons() {
  // the link to tables on the tooltip "See all county data"
  $("div.county-link").on("click",function(){
    var county = CONFIG.selected_place;
    update_table(county);
    return false; 
  });

  // the X on tooltip: closes the tooltip, deselects the county, resets map opacity
  // tooltip can only be opened again by clicking the map
  $("div.county-tooltip div.close-tooltip").on("click", function(){
    reset_viz();
  });

  // "un-mute" the map on background clicks in left and right col
  // using mousedown here to match mousedown listeners on the map and barchart
  // instead of "click" which was not working in ie11
  $("div#map-wrapper, div#chart-wrapper").on("mousedown",function(e){
    // kludge: couldn't find a way to avoid propogating clicks on these elements down to the map
    if (e.target.classList.contains("show-more") || 
        e.target.classList.contains("fa") || 
        e.target.classList.contains("notes-sources") ||
        // table rows: 
        e.target.classList.contains("county-table") ||
        e.target.classList.contains("indicator") ||
        e.target.classList.contains("basetext") || 
        e.target.classList.contains("basetext_light")  
        ) return;
    reset_viz();   
  });
}

// construct bootstrap dropdown nav from nested dimensions > indicators
function initNav() {
  // construct the navbar, with classes for both D3 and bootstrap
  // corresponds to: <div id="navbar" class="navbar-collapse collapse">
  d3.select("#navbar").append("ul")
    .attr("class", "metric-list nav navbar-nav")
    .attr("id","navbar");

  // set up metric_list, bind DATA.dimensions to it and begin to construct bootstrap nav
  // corresponds to: <ul class="nav navbar-nav">
  var metric_list = d3.selectAll(".metric-list")
    .selectAll("li")
    .data(DATA.dimensions)
    .enter()
    .append("li")
    .attr("class","dropdown");

  // add "selected" class to the very first dimension, which is "on" when the app loads
  metric_list.filter(function(d, i) { return i == 0})
    .classed("selected", true);

  // continue constructing boostrap nav from DIMESIONS data: top level nav for dimensions
  metric_list
    .append("a").html(function(d) {
      return LOOKUP[d.key]["short_title"] + "<i class='fas fa-chevron-right'></i>";
    })
    // add boostrap classes
    .classed("dropdown-toggle",true)
    .attr("data-toggle","dropdown")
    .attr("role","button")
    .attr("aria-haspopup","true")
    .attr("aria-expanded","false");

  // continue constructing boostrap nav from DIMESIONS data: dropdown nav for indicators
  metric_list
    .append("ul").attr("class","dropdown-menu")
    .selectAll("li")
    .data(function(d) { return d.values; })
    .enter().append("li").append("a")
    .attr("class", "indicator")
    .text(function(d) {
      d.key = d.values[0].indicator; 
      // then construct the nav text
      return LOOKUP[d.key]["short_title"]; 
    }).on("click", function(d) {
      redraw(d);
      highlight_table_row(d);
    });

  // Final hack: add align right class to the last one
  d3.select(d3.selectAll(".metric-list ul.dropdown-menu").nodes().pop()).classed('dropdown-menu-right',true);


  // make selected indicator style persist even after dropdown closes
  // nav itself is constructed from data in construct_nav()
  // do this after a given dropdown has finished showing    
  $('nav.navbar').on('shown.bs.dropdown', function () {
    // remove any existing selected from all of them
    $('li.dropdown').removeClass('selected');
    // now get the currently selected one
    var selected = $('ul#navbar').find('li.dropdown.show');
    selected.addClass('selected');
  })

};


//////////////////////////////////////////////////////////
// Named functions
//////////////////////////////////////////////////////////

// The primary map and chart rendering controller: 
// does the initial processing of data for this indicator and dispatches sub-functions to draw the barscharts and map
function redraw(indicator) {
  // reset the global CONFIG.active_ind to this indicator, then filter the METRIC LIST and reset the active class to this indicator5
  CONFIG.active_ind = indicator;
  var metric_list = d3.selectAll(".metric-list");
  metric_list.selectAll("li").classed("active", false);
  metric_list.selectAll("li").filter(function(d) { return d == indicator; }).classed("active", true);

  // update the dimension and indicator text below the indicator label
  let dimension = indicator.values[0].dimension;
  d3.select("div#dimension-text").text(LOOKUP[dimension]["long_title"]);
  
  // update indicator label and text above the map, 
  d3.select("div#indicator-label").text(LOOKUP[indicator.key]["short_title"]);
  d3.select("div#indicator-text").text(LOOKUP[indicator.key]["long_title"]);

  // check if we are on a university indicator, or not
  var old_univ = CONFIG.university;
  CONFIG.university = CONFIG.university_indicators.indexOf(indicator.key) > -1 ? true : false;
  // if we are switching "views" from counties to universities
  // deselect the current place 
  // as the county/university we were focused on, no longer applies
  // also hide any open table, as the two table types are not comparable
  if (CONFIG.university != old_univ) {
    deselect_county();
    deselect_county_bar();
    hide_county_table(); 
    hide_tooltip();
    CONFIG.selected_place = null;
  } 

  // get min-max values for the current data selection, used in the barscale domain
  var min = d3.min(indicator.values, function(d) { return d.value; }); // min only used for the legend
  var max = d3.max(indicator.values, function(d) { return d.value; }); // max used in legend and to scale the bar chart

  // set up a linear scale for the bar chart bar widths
  var chartwidth = CONFIG.university ? CONFIG.university_barchart_width : CONFIG.county_barchart_width;
  var rangemax = $("div#chart-wrapper").width() - (chartwidth / 2);
  var range = [2, rangemax];
  var barscale = d3.scaleLinear()
    .domain([0,max])
    .range(range);

  // set up a linear scale for the ethnicity bar chart
  var ethdata = DATA.ethnicity.filter(function(d) {
    return d.indicator == indicator.key;
  });
  var maxeth = d3.max(ethdata, function(d) { return d.value }); // max used for the ethnicity barchart, maybe different than max of all data
  var rangemax = $("div#ethnicity-wrapper").width();
  var ethscale = d3.scaleLinear()
    .domain([0, maxeth])
    .range([2, rangemax]);

  // update lookup with indicator values for this county 
  indicator.values.forEach(function(d) {
    CONFIG.ind_lookup[d.geography] = d;
  });
  
  // set up the colorscale for the map and barchart
  // this is based on min, max ranks
  var low = d3.min(indicator.values, function(d) { return d.rank });
  var high = d3.max(indicator.values, function(d) { return d.rank });
  var colorscale = d3.scaleLinear()
    .domain([low, high])
    .range([0, 1]);

  let count = high - low; // a count of the ranks in this set

  // eth values aren't ranked, so we use the following to tell when to reverse the sort for the eth barchart
  var value_at_min_rank = indicator.values.filter(function(d) {
    return d.rank == low;
  });
  var value_at_max_rank = indicator.values.filter(function(d) {
    return d.rank == high;
  });
  var reverse = value_at_min_rank[0].value > value_at_max_rank[0].value;

  // dispatch indicator values to all the main application elements for refresh
  update_tooltip(CONFIG.ind_lookup[CONFIG.selected_place]);          // update the tooltip, every time except first load
  update_county_barchart(indicator, colorscale, barscale);           // draw the county barchart
  update_ethnicity_barchart(ethdata, ethscale, indicator, reverse);  // draw (or hide) the ethnicity barchart
  update_plumblines(indicator, barscale);                      // update chart plumblines with NJ data
  update_ethnicity_plumblines(indicator, ethscale);            // update ethnicity chart plumblines with NJ data
  update_map(indicator, colorscale);                           // draw or refresh the map
  update_legend(min,max,indicator.values[0].datatype, colorscale, reverse, count);   // draw the legend
  update_notes_sources(indicator);                             // update the notes and/or sources text
  update_ethnicity_barchart_height(indicator);                 // resize eth barchart wrappers based on current content

}; // end redraw()


// parent function for updates that need to happen when the county changes
function select_county(county) {
  select_place_on_map(county);
  select_county_on_barchart(county);
  CONFIG.selected_place = county;
}

// deselect any selected (clicked) county on the map, and reset the original view 
function deselect_county() {
  // remove map styles
  d3.selectAll(".counties path")
    .classed("click", false)
    .style("opacity", CONFIG.default_opacity)
    .style("stroke", null)
    .style("stroke-width", null);
};

// deselect any selected (clicked) county on the barchart, and reset the original view 
function deselect_county_bar() {
  // remove county bar highlight and bolding
  d3.selectAll("div.county")
    .style("opacity", CONFIG.default_opacity)
    .classed("bold",false);

  // reset the eth chart and colleges, special for the university case
  if ( CONFIG.university ) {
    d3.select("h3.ethchart-title").text("Statewide by Race and Ethnicity");
    d3.select("div.ethnicity-list").style("display", "none");
    d3.select("div#ethnicity-message").style("display", "block");    

    d3.selectAll("circle.university")
      .style("stroke", null)
      .style("stroke-width", null)
      .classed("click",false)
      .classed("hover",false);

  }
};

// map click: select the place and apply some opacity effects to the rest of the map
function select_place_on_map(place) {
  // universities and counties have different pathways
  if (CONFIG.university) {
    // first remove all highlighting from the circles on the map
    var circles = d3.selectAll("circle.university")
      .style("opacity", 0.85)
      .style("stroke", "none")
      .style("stroke-width", null);

    // any currently selected circle needs a slightly different reset
    d3.selectAll("circle.university.click")
      .style("opacity", 0.85)
      .style("stroke", null)
      .style("stroke-width", 0);
    
    // remove the click class from any existing paths and
    circles.classed("click", false);

    // filter the selected university, add highlighting and a "click" class
    circles.filter(function(d) { return d.geography == place; })
      .classed("click", true)
      .style("opacity", CONFIG.default_opacity)
      .style("stroke", CONFIG.selected_place_color)
      .style("stroke-width", "2px");

  } else {
    // remove all highlighting from the counties on the map
    var path = d3.selectAll(".counties path")
      .style("opacity", 0.85)
      .style("stroke", "none")
      .style("stroke-width", null);

    // any currently selected county needs a slightly different reset
    d3.selectAll(".counties path.click")
      .style("opacity", 0.85)
      .style("stroke", null)
      .style("stroke-width", 0);
    
    // remove the click class from any existing paths and
    path.classed("click",false);

    // filter the selected county, add highlighting and a "click" class
    path.filter(function(d) { return d.properties.id == place; })
      .attr("class","click")
      .style("opacity", CONFIG.default_opacity).style("stroke", CONFIG.selected_place_color).style("stroke-width", "2px")
      .raise();
  }

}

// click barchart: highlight the selected bar, dim the others 
function select_county_on_barchart(county) {
  // "dim" all bars
  var county_bars = d3.selectAll("div.county")
    .style("opacity", "0.4")
    .classed("bold", false);

  // and higlight the selected bar with full opacity and bold font
  county_bars.filter(function(d) {
    return (d.geography == county);
  }).style("opacity", "1").classed("bold",true);
};

// generic function to hover a county or a university by name
// pass a "null" countyname for mouseout
function hover_place_by_name(placename) {
  // un-highlight the non-selected counties on the map 
  d3.selectAll(".counties path:not(.click)")
    .style("opacity", "0.85")
    .style("stroke", function() { if (! CONFIG.university) return "none" }) // counties only
    .style("stroke-width", function() { if (! CONFIG.university) return null }); // counties only

  d3.selectAll("circle.university:not(.click)")
    .style("stroke", null)
    .style("stroke-width", null)
    .classed("hover",false);

  // ... and in the bar chart
  var county_bars = d3.selectAll("div.county:not(.bold")
    .style("opacity", "0.4");
    // .filter(function(d) { return d.geography == placename; });
  
  // if no place name was given, this is a mouseout, and we undim
  if (! placename) {
    // check if there is a click-selected place on the map - if so, we're done
    if ( $("path.click").length || $("circle.click").length ) {
      return;
    } else {
      // we have a selected county:
      // "undim" the map completely
      d3.selectAll(".counties path:not(.click)")
      .style("opacity", CONFIG.default_opacity)
      .style("stroke", null)
      .style("stroke-width", null)
      .classed("hover",false);
    
      // undim the bars completely
      d3.selectAll("div.county").style("opacity", CONFIG.default_opacity);
    
      // universities on the map
      if (CONFIG.university) {
        d3.selectAll("circle.university:not(.click)")
        .style("opacity", CONFIG.default_opacity)
        .style("stroke", null)
        .style("stroke-width", null)
        .classed("hover",false);
      }
    }
  } 

  // highlight the selected place on the map and in the left-bar
  var counties = d3.selectAll(".counties path:not(.click)")
    .filter(function(d) { return d.properties.id == placename; })
    .classed("hover", true)
    .style("opacity", CONFIG.default_opacity)
    .style("stroke", CONFIG.hovered_place_color)
    .style("stroke-width", "2px")
  
  // and highlight the university on the map
  if (CONFIG.university) {
    d3.selectAll("circle.university:not(.click)")
        .filter(function(d) { return d.geography == placename; })
        .classed("hover", true)
        .style("opacity", CONFIG.default_opacity)
        .style("stroke", CONFIG.hovered_place_color)
        .style("stroke-width", "2px")
  }

  // reassert the hovered county to the very front
  // but not on EDGE, which can't handle this SVG shuffling
  // // which seems to break expected mouseout behavior some of the time
  // if (! EDGE) counties.raise(); 

  // // reassert the selected county to the very front
  // d3.select(".counties path.click").raise();  

  // unselect the bars
  d3.selectAll("div.county:not(.bold")
    .filter(function(d) { return d.geography == placename; })
    .style("opacity", CONFIG.default_opacity);
};

// update and display the tooltip with current selection 
function update_tooltip(place) {
  if (!place) return;
  // update the header with this place name and formatted value (NA if rank == 0)
  var value = place.rank > 0 ? place.formatted : "NA";
  d3.selectAll("div.county-tooltip h4").text(LOOKUP[place.geography]["short_title"] + ": " + value);
  // the change to mousedown/mouseup to fix ie11 bug has made this necessary; need to block these propogating to the div behind, which simply closees the popup
  d3.selectAll("div.county-tooltip").on('mousedown',function(e){ d3.event.stopPropagation() });
  d3.selectAll("div.county-tooltip").on('mouseup',function(e){ d3.event.stopPropagation() });
  // update the place type
  d3.selectAll("div.county-tooltip span.place").text(function() { return CONFIG.university ? "University" : "County" });
}

// we need to abstract showing the tooltip from updating the tooltip
// always update but only show on map click
function show_tooltip() {
  // show the tooltip, nothing fancy
  let which = isMobile() ? "mobile" : "desktop";
  d3.select(`div.county-tooltip.${which}`).style("display","block");
}


// simple function to hide any showing tooltip
function hide_tooltip() {
  d3.selectAll("div.county-tooltip").style("display","none");
}

// update the county bar chart
function update_county_barchart(ind, colorscale, barscale) {
  // get widths and heights
  var chartwidth = CONFIG.university ? CONFIG.university_barchart_width : CONFIG.county_barchart_width;
  var barheight = CONFIG.university ? CONFIG.university_bar_height : CONFIG.county_bar_height;

  // filter data to remove statewide value, and ranks that are 0
  var county_indicators = ind.values.filter(function(d) {
    return d.geography !== CONFIG.statename && d.rank > 0;
  });

  // update the county bar chart data
  // var county_barchart = d3.selectAll(".county-list");
  var chart = d3.select(".county-list");

  // bind data with a key function 
  var county_items = chart.selectAll("div.county")
    // .data(randomLetters(), function(d) { return d })
    .data(county_indicators, function(d) { return d.geography })
    .join(
        enter => enter.append("div")
            .attr("class", "county")
            .style("height", barheight + "px")
            .classed("university", function() { return CONFIG.university; })
            .classed("hover", false)
            .style("top", (d, i) => i * barheight + "px")
            .style("opacity", "1"),
        update => update,
        exit => exit
            .remove()
      )
      .on("click", function(d) {
        // update the global for selected county name
        CONFIG.selected_place = d.geography;

        // when you click a bar, highlight the selected county on the chart
        // but first, if you click an already selected bar - clear the selection
        var bar = d3.select(this);
        if (bar.classed("bold")) {
          reset_viz();
          return;
        }
        // ok, no existing selection, continue
        bar.classed("bold",true);
        // select the county on the map and barchart, and update the tables 
        select_county(d.geography);

        // update and open the tooltip for the newly selected county
        update_tooltip(CONFIG.ind_lookup[d.geography]);
        show_tooltip(d);

        // special behavior for univerisities bars:
        // update the eth/race barchart for this one college
        if (CONFIG.university) {
          update_univerisity_ethnicity_barchart(d, ind)
        }

        // if table is showing, update it with data from currently selected county
        var table_wrapper = d3.select(".county-table");
        if (table_wrapper.style("display") == "block") update_table(d.geography);

        // see initButtons(). We use background clicks to clear the app, so stop propogation on this click
        d3.event.stopPropagation();
    })
    // repetitive, but the only way I could get stopPropagation to work
    // (otherwise clicks propogate to the background, and trigger reset_viz())
    .on("mousedown",function(){ d3.event.stopPropagation() });
  
  // for non-touch, non-mobile devices only, register some hover events on the county map
  // including isMobile() || isIpad() here to include iPad and exclude "other" touch devices here, e.g. my laptop
  if (! (isTouch() && (isMobile() || isIpad() ) ) ) {
    county_items
      .on("mouseenter", function(d) {
        hover_place_by_name(d.geography);
      })
      .on("mouseleave", function(){
        hover_place_by_name(null);
      });
  }

  // county_labels: re-select and bind data
  var county_rows = d3.selectAll("div.county");
  var county_labels = county_rows.selectAll(".county-label")
    .data(function(d) { return [d]; })
    .join(
        enter => enter.append("span")
            .attr("class", "county-label")
            .classed("university", function() { return CONFIG.university; })
            .style("top", (d, i) => i * barheight + "px")
            .text(d => `${LOOKUP[d.geography]["short_title"]}, ${d.formatted}`),
        update => update
            .text(d => `${LOOKUP[d.geography]["short_title"]}, ${d.formatted}`),
        exit => exit
            .style("color", "white")
            .remove()
      );

  // county_bars: select, join, update
  var county_rows = d3.selectAll("div.county");
  var county_bars = county_rows.selectAll("div.bar")
    .data(function(d) { return [d] })
    .join(
        enter => enter.append("div")
            .attr("class", "bar")
            .classed("university", function() { return CONFIG.university; })
            .style("width", function(d) { return barscale(d.value) + "px"; })
            .style("background", function(d) { return d3[CONFIG.colorscheme](colorscale(d.rank)) })
            .style("top", (d, i) => i * barheight + "px")
            .style("height", barheight + "px"),
        update => update
            .style("width", function(d) { return barscale(d.value) + "px"; })
            .style("background", function(d) { return d3[CONFIG.colorscheme](colorscale(d.rank)) }),
        exit => exit
            .remove()
      );

  // shuffle the bars by changing style("top"). 15px each, 15*j px from the top
  county_items
    .sort(function(a, b){
        return d3.ascending(a.rank, b.rank);
     })
    .transition().duration(500)
    .delay(function(d,i) { return 500+10*i; })
    .style("top", function(d,i) { return (barheight*i) + "px"; });


  // hack: reapply selection, if there is one
  // see #18
  if (CONFIG.selected_place) select_county(CONFIG.selected_place);

  // resize bar wrapper to fit this set of bars
  var height = county_items.size() * barheight;
  $("div.county-list").height(height);

}

// update and format the ethnicity bar chart 
function update_ethnicity_barchart(ethnicity_subset, ethscale, ind, reverse) {
  // get the barchart div, and filter to the subset of data for this indicator
  var ethnicity_barchart = d3.selectAll(".ethnicity-list");
  var ethnicity_message = d3.select("#ethnicity-message");

  // update the title, always, to show the statewide message
  // see circles .on('mousedown') where this gets changed when an individual college is clicked
  if (! CONFIG.university) d3.select("h3.ethchart-title").text("Statewide by Race and Ethnicity");

  // sort by value
  // to do: we need a "reverse" flag!!
  ethnicity_subset.sort(function(a,b) { 
    if (reverse) return b.value - a.value;
    return a.value - b.value; 
  });

  // these two indicators, only, have additional sorting and splitting
  let police = CONFIG.police_use_of_force_indicators.indexOf(ind.values[0].indicator) > -1;
  if (police) {
    // special sort
    // first, make two subsets: subjects and officers
    let subjects = ethnicity_subset.filter(function(d) { return d.group.indexOf('subject') > -1 && d.group.indexOf('officer') < 0 });
    let officers = ethnicity_subset.filter(function(d) { return d.group.indexOf('officer') > -1 });
    // sort them, just to be sure
    subjects.sort(function(a,b) {
      if (reverse) return b.value - a.value;
      return a.value - b.value; 
    });
    officers.sort(function(a,b) {
      if (reverse) return b.value - a.value;
      return a.value - b.value; 
    });

    // concatenate these two arrays together, replacing the original ethnicity_subset
    ethnicity_subset = subjects.concat(officers);
    // see below for additional chart tweaks
  }


  // show or hide ethnicity barchart div, with conditions, depending on data for this attribute
  var eth_div = d3.select("div#ethnicity-wrapper");
  if (ind.key == ind.values[0].indicator) {
    // show the div!
    eth_div.style("display","block");
    // but wait.. is there data? If not, display a "special message"
    if (!ethnicity_subset.length) {
      ethnicity_barchart.style("display","none");
      // but wait... is this a university? If so, change the message
      ethnicity_message
        .text(function() { return CONFIG.university ? "Click a college on the map or barchart to show race and ethnicity data." : "Data not available by race and ethnicity for this indicator." })
        .style("display","block");     
    } else {
      ethnicity_barchart.style("display","block");
      ethnicity_message.style("display","none");
    }
  } else {
    // not an indicator, hide the div
    eth_div.style("display",null);         
  }

  // group and bind ethnicity data, and create outer rows
  var ethnicity_items = ethnicity_barchart.selectAll("div.ethnicity")
    .data(ethnicity_subset, function(d) { return d.group; })
    .join(
      enter => enter.append("div")
        .attr("class", "ethnicity")
        .style("top", function(d,i) {
          let amount = CONFIG.ethnicity_bar_height*i;
          // for the two "police" indicators, add spacing between the two series
          let factor = police && i >= 4 ? 10 : 0;  
          let top = amount + factor;
          return `${top}px`;
        }), 
      update => update,
      exit => exit.remove()
    );

  // eth_bars: select, join, update
  var eth_rows = d3.selectAll("div.ethnicity");
  var eth_bars = eth_rows.selectAll(".bar")
    .data(function(d) { return [d]; })
    .join(
        enter => enter.append("div")
          .attr("class", "bar")
          .style("height", d => `${CONFIG.ethnicity_bar_height - 2}px`)
          .style("width", d => `${ethscale(d.value)}px`)
          .style("background", CONFIG.ethnicity_bar_color),
        update => update
          .style("width", d => (isNaN(d.value)) ? 0 : `${ethscale(d.value)}px`),
        exit => exit
          .remove()
      );

  // eth_labels: re-select and bind data
  var eth_rows = d3.selectAll("div.ethnicity");
  var eth_labels = eth_rows.selectAll(".eth-label")
    .data(function(d) { return [d]; })
    .join(
        enter => enter.append("span")
            .attr("class", "eth-label")
            // .style("top", (d, i) => i * CONFIG.ethnicity_bar_height + "px")
            .text(d => (d.group in LOOKUP ? LOOKUP[d.group]["short_title"] : d.group) + ", " + d.formatted),
        update => update
            .text(d => (d.group in LOOKUP ? LOOKUP[d.group]["short_title"] : d.group) + ", " + d.formatted),
        exit => exit
            .style("color", "white")
            .remove()
      );


  // shuffle the bars by changing style("top"). 15px each, 15*j px from the top
  ethnicity_items
    .transition().duration(500)
    .delay(function(d,i) { return 500+10*i; })
    .style("top", function(d,i) { 
      let amount = CONFIG.ethnicity_bar_height*i;
      // for the two "police" indicators, add spacing between the two series
      let factor = police && i >= 4 ? 10 : 0;
      let top = amount + factor;
      return `${top}px`;
    });
}

// Update plumb lines or hide if no Statewide data
function update_plumblines(ind, barscale) {
  // select the barchart
  var county_barchart = d3.selectAll(".county-list");

  // filter data to get statewide indicator value
  var statedata = ind.values.filter(function(d) {
    return d.geography == CONFIG.statename;
  });

  // calculate county bar height as a function of the number of bars, and the barheight of those bars, plus a little extra
  var barheight = CONFIG.university ? CONFIG.university_bar_height : CONFIG.county_bar_height;
  var county_plumbheight = (d3.selectAll("div.county").size() * barheight) + 8;

  if (statedata.length > 0) {
    county_barchart.select(".plumb-line")
      .transition()
      .style("opacity", 1)
      .style("left", (CONFIG.county_barchart_width / 2) + barscale(statedata[0].value) + "px")
      .style("height",county_plumbheight + "px");
    county_barchart.select(".plumb-label")
      .transition()
      .style("opacity", 1)
      // .style("left", (CONFIG.county_barchart_width / 2) + barscale(statedata[0].value)-20 + "px")
      .text(LOOKUP[CONFIG.statename].short_title + ", " + statedata[0].formatted);
    
      // plumb-label label placement: we don't want to overflow left or right
      setTimeout(function() {
        let plumblabel = $('.county-list .plumb-label');
        let labelwidth = plumblabel.width();
        // the starting left position is right where the plumb-line is
        let startleft = (CONFIG.county_barchart_width / 2) + barscale(statedata[0].value);
        let maxwidth = (CONFIG.county_barchart_width / 2) + barscale(barscale.domain()[1]);
        // default placement: centered around the plumbline
        let defaultleft = startleft - (labelwidth / 2); 

        // test for overflow on the right
        // overflow on the left is unlikely, as we have a col of labels that are more than 100px wide
        if (startleft + (labelwidth / 2) > maxwidth) {
          defaultleft = defaultleft - ( (startleft + (labelwidth / 2)) - maxwidth  ) - 5;
        }

        // now place it
        plumblabel.css('left', defaultleft);
      }, 200);

    } else {
      // no state data: hide
      county_barchart.select(".plumb-line")
        .transition()
        .style("opacity", 0)
      county_barchart.select(".plumb-label")
        .transition()
        .style("opacity", 0)
      }

}

function update_ethnicity_plumblines(ind, ethscale) {
  var ethnicity_barchart = d3.selectAll(".ethnicity-list");

  // calculate ethnicity bar chart height, as the number of categories varies
  var eth_plumbheight = (d3.selectAll("div.ethnicity").size() * CONFIG.ethnicity_bar_height) + 8;

  // filter data to get statewide indicator value
  var statedata = ind.values.filter(function(d) {
    return d.geography == CONFIG.statename;
  });

  if (statedata.length > 0) {
    ethnicity_barchart.select(".plumb-line")
      .transition()
      .style("opacity", 1)
      .style("left", ethscale(statedata[0].value) + "px")
      .style("height",eth_plumbheight + "px");
    ethnicity_barchart.select(".plumb-label")
      .transition()
      .style("opacity", 1)
      .text(LOOKUP[CONFIG.statename].short_title + ", " + statedata[0].formatted);
      
      // eth plumb-label label placement: we don't want to overflow left or right
      // since we have this chart in a line-delimited box
      setTimeout(function() {
        let plumblabel = $('.ethnicity-list .plumb-label');
        let labelwidth = plumblabel.width();
        // the starting left position is right where the plumb-line is
        let startleft = ethscale(statedata[0].value);
        let maxwidth = ethscale(ethscale.domain()[1]);
        // default placement: centered around the plumbline
        let defaultleft = startleft - (labelwidth / 2); 

        // test for overflow on the right
        if (startleft + (labelwidth / 2) > maxwidth) {
          defaultleft = defaultleft - ( (startleft + (labelwidth / 2)) - maxwidth  ) - 5;
        }

        // test for overflow on the left, which is anything less than 16px, the padding on the wrapper div
        if (defaultleft < -16) {
          // just nudge it 10px to the left of plumb-line, which can never be below 0
          defaultleft = startleft - 10
        }

        // now place it
        plumblabel.css('left', defaultleft);
      }, 200);

  } else {
    // no state data: hide
    ethnicity_barchart.select(".plumb-line")
      .transition()
      .style("opacity", 0)
    ethnicity_barchart.select(".plumb-label")
      .transition()
      .style("opacity", 0)
  }
}

// Draw/update the map for the selected indicator
function update_map(indicator, colorscale) {
  // remove existing circles no matter what, as we're not able to do the usual enter/update/exit cycle here
  d3.selectAll("circle.university").remove();
  d3.selectAll("path.nodata-marker").remove();

  if ( CONFIG.university ) {
    // reset the map, and remove hover effects
    deselect_county();
    d3.selectAll(".counties path")
      .on("mousedown", null)
      .on("mouseup", function() { d3.event.stopPropagation(); })
      .on("mouseenter", null)
      .on("mouseleave", null)
      .each(function(d) {
        d3.select(this).style("fill","#fff").style("cursor", "default");
      });

    var map = d3.select("svg");

    let nodata_universities = [];
    var circles = map.selectAll("circle.university")
      .data(DATA.universities)
      .enter()
      .append("circle")
      .attr("class", "university")
      .attr("cx", function (d) { return CONFIG.projection([d.lon, d.lat])[0]; })
      .attr("cy", function (d) { return CONFIG.projection([d.lon, d.lat])[1]; })
      .attr("r", CONFIG.university_circle_radius)
      .attr("fill", function(d) { 
        let unidata = indicator.values.filter(function(i) { return i.geography == d.geography})[0];
        // color unidata with a rank, and keep circles white for those without a rank
        // these will get different treatment in the next step
        if (unidata.rank > 0) {
          return d3[CONFIG.colorscheme](colorscale(unidata.rank))
        } else {
          nodata_universities.push(unidata);
          return "#cecece";
        }
      })
      // click behavior: very similar to that of the counties, open a tooltip for the University
      // define map click functionality
      // this was "click", but click was not working in IE11
      .on("mousedown", function(d) {
        // select this place
        select_county(d.geography);

        // update tooltip content, and show it
        let unidata = indicator.values.filter(function(i) { return i.geography == d.geography})[0];
        update_tooltip(unidata);
        show_tooltip(d);

        // special behavior for univerisities bars:
        // update the eth/race barchart for this one college
        update_univerisity_ethnicity_barchart(d, indicator);

        // set the currently selected county
        CONFIG.selected_place = unidata.geography;
        
        // only relevant on mobile: keep the county select in sync with what is on the map
        $('select.university-select').val(unidata.geography);

        // see initButtons(), we use background clicks to do stuff
        d3.event.stopPropagation();
      })
      .on("mouseup",function(d){
        // see initButtons(), we use background clicks to do stuff
        d3.event.stopPropagation();
      });

      // for non-touch, non-mobile devices only, register some hover events on the county map
      // including isMobile() || isIpad() here to include iPad and exclude "other" touch devices here, e.g. my laptop
      if (! (isTouch() && (isMobile() || isIpad() ) ) ) {
        circles
          .on("mouseenter", function(d) {
            hover_place_by_name(d.geography, true);
          })
          .on("mouseleave", function(d){
            hover_place_by_name(null, true);
          });
      }

      // add circle-with-slash "markers" where rank = 0 (no data condition)
      // no click events on the path: we use pointer-events:none; to pass through to the underlying <circle>
      let map = d3.select("svg");
      nodata_universities.forEach(function(d) {
        let unidata = DATA.universities.filter(function(i) { return d.geography == i.geography})[0];
        let x = CONFIG.projection([unidata.lon, unidata.lat])[0];
        let y = CONFIG.projection([unidata.lon, unidata.lat])[1];

        var nodatapaths = map.append("svg:path")
          .classed("nodata-marker", true)
          .attr("d", function() { 
            return getCircleWithSlash(x, y, CONFIG.university_circle_radius - 1);
          });
      });

  } else {
    // the usual county map
    var counties = d3.selectAll(".counties path")
      .each(function(d) {
        d.active = CONFIG.ind_lookup[d.properties.id.toLowerCase()];
        d3.select(this)
        // trap counties with a rank of 0 for selected indicator, color grey
        // .style("fill", d.active.rank > 0 ? colorscale(d.active.rank) : "#cecece"  );
        .style("fill", d.active.rank > 0 ? d3[CONFIG.colorscheme](colorscale(d.active.rank)) : "#cecece"  )
        .style("cursor", "pointer");
    })
    // define map click functionality
    // this was "click", but click was not working in IE11
    .on("mousedown", function(d) {
      if (d3.select(this).classed("click")) { reset_viz(); return; };
      // otherwise, this is a new selection: select and show the clicked county
      select_county(d.active.geography);

      // update tooltip content, and show it
      update_tooltip(d.active);
      show_tooltip(d);

      // set the currently selected county
      CONFIG.selected_place = d.active.geography;
      
      // see initButtons(), we use background clicks to do stuff
      d3.event.stopPropagation();
    })
    .on("mouseup",function(d){
      // see initButtons(), we use background clicks to do stuff
      d3.event.stopPropagation();
    });

    // for non-touch, non-mobile devices only, register some hover events on the county map
    // including isMobile() || isIpad() here to include iPad and exclude "other" touch devices here, e.g. my laptop
    if (! (isTouch() && (isMobile() || isIpad() ) ) ) {
      counties
        .on("mouseenter", function(d){
          hover_place_by_name(d.properties.id);
        })
        .on("mouseleave", function(d){
          hover_place_by_name(null);
        });
    }
  }
}


// update the eth barchart for this one university
// note this is outside of the typical update flow where barcharts get updated!
function update_univerisity_ethnicity_barchart(data, indicator) {  
  // set up a linear scale for the ethnicity bar chart
  var ethdata = DATA.ethnicity_colleges.filter(function(d) {
    return d.indicator == indicator.key && d.geography == data.geography;
  });
  var max = d3.max(ethdata, function(d) { return d.value }); // max used for the ethnicity barchart, maybe different than max of all data
  var rangemax = $("div#ethnicity-wrapper").width();
  var ethscale = d3.scaleLinear()
    .domain([0,max])
    .range([2, rangemax]);
  
  // update the chart, plumbline, and resize
  update_ethnicity_barchart(ethdata, ethscale, indicator);
  update_ethnicity_plumblines(indicator, ethscale);
  update_ethnicity_barchart_height(indicator);

  // update the eth barchart title
  d3.select("h3.ethchart-title").text(`By Race and Ethnicity: ${LOOKUP[data.geography]["short_title"]}`);
}


// update the notes and sources text blocks
function update_notes_sources(ind) {
  // get the lookup
  var lookup = LOOKUP[ind.key];

  // Notes: hide initially
  var notes_block = d3.selectAll("div#notes").style("display","none");
  notes_block.selectAll("div").remove();

  // append new notes, if they exist
  if (lookup.notes) {
    notes_block
      .style("display","block")
      .append("div")
      .attr("class","notes-sources")
      .html(linkify(lookup.notes));
  }

  // Sources: hide initially
  var source_block = d3.selectAll("div#sources").style("display","none")
  source_block.selectAll("div").remove();
  // append and show source if present
  if (lookup.data_source) {
    source_block
      .style("display","block")
      .append("div")
      .attr("class","notes-sources")
      .html(linkify(lookup.data_source));
  }

  // Race/Eth notes: hide initially
  // append ethnicity notes, if they exist
  d3.selectAll("div#ethnicity-wrapper div#ethnicity-notes").remove();
  if (lookup.race_notes) {
    var notes = d3.selectAll("div#ethnicity-wrapper")
      .append("div")
      .attr("id", "ethnicity-notes")
    
    notes.append("span")
      .attr("class", "source-title")
      .text("Notes")
    
    notes.append("div")
      .attr("class","notes-sources")
      .html(lookup.race_notes);
  }
}

// update the ethbarchart wrapper height, based on the presence or absence of various things
function update_ethnicity_barchart_height(ind) {
  setTimeout(function() {
    // resize ethnicty chart to fit the current set of bars, or 0, if there are no bars
    var height = $("div.ethnicity").length * CONFIG.ethnicity_bar_height;
    if (CONFIG.police_use_of_force_indicators.indexOf(ind.values[0].indicator) > -1) height += 10;

    // account for presence or absence of the plumb label
    var margin = $("div.ethnicity-list div.plumb-line").css("opacity") != "0" ? 40 : 0;

    // set the width, margin
    $("div.ethnicity-list").height(height).css('margin-top', margin)
  }, 100)
}


// update the legend that shows next to the map
function update_legend(min, max, format, colorscale, reverse, count) {
  // apply colors across an arbitrary domain of ranks equal to the number of counties
  var ranks = [];
  for (var i = 1; i <= count; i++) {
     ranks.push(i);
  }

  if (reverse) ranks.reverse();

  // update the legend itself
  var legend = d3.select("div#legend").html("");
  legend.selectAll("div.legend-item")  
    .data(ranks)
    .enter()
      .append("div")
      .attr("class","legend-item")
      .style("background-color", function(d,i) { return d3[CONFIG.colorscheme](colorscale(ranks[i])); })
      .style("width", 150 / ranks.length + "px");

  // append legend labels
  d3.selectAll("div.legend-labels").remove();
  var labels = legend.append("div")
      .attr("class","legend-labels");
  
  // update legend labels
  labels.selectAll("span")
    .data([min,max])
    .enter()
      .append("span")
      .text(function(d){ return CONFIG.format[format](d) });
}

// Creates and refreshes the county table view
function update_table(county) {
  // first: hack the columns to allow the table to fit across the right side
  $('div#map-wrapper').removeClass('col-lg-4').addClass('col-lg-8');
  $('div#ethnicity-outer').css("position", "relative").css("left", "-9999px");

  // hide the sources divs below the map, as these just get cut off by the table
  $('div#notes-wrapper').hide();

  // create county data object; nested dimensions > indicators > values for this one county
  var county_data = d3.nest()
    .key(function(d) { return d.dimension; })
    // TO DO
    // .sortKeys(function(a,b){
    //   return CONFIG.dimension_order.indexOf(a) - CONFIG.dimension_order.indexOf(b);
    // })
    .key(function(d) { return d.indicator; })
    // TO DO
    // .sortKeys(function(a,b){
    //   return CONFIG.indicator_order.indexOf(a) - CONFIG.indicator_order.indexOf(b)
    // })
    .entries(DATA.county_data.filter(function(d) { return d.geography == county; }));

  // show and also clear existing table
  var table_wrapper = d3.select(".county-table");
  table_wrapper.style("display", "block")
    .html("");

  // construct the table div, and add buttons
  var buttons = table_wrapper.append("div")
    .attr("id", "button-wrapper");

  // add a table close button
  buttons.append("div")
    .attr("id", "close-wrapper")
    .attr("class", "table-button")
    .attr("title", "Back to map")
    .html("<span>Back to map</span>")
    .on("click", function(e) {
      hide_county_table();
    })
    .on("mousedown", function() {
      // only way I could get this to stop propogating, was via mousedown
      d3.event.stopPropagation();
    })
    .append("i")
      .attr("class","fas fa-times-circle");

  // construct the table html itself and bind "data" really just a single row of text appended to a <th>
  var table = table_wrapper.append("table").attr("class","county-table");
  table.append("thead")
    .append("tr")
    .selectAll("th")
    .data([
      LOOKUP[county].long_title, 
      "<span id='table-value'>Value<br><span style='font-size:80%; display: block; line-height: 1.2'>(Margin of Error)</span></span>",
      "Statewide value",
      ])
    .enter().append("th")
    .html(String);

  // sets up the <tbody> and binds county data to rows
  // inits functionality to redraw indicator on row click 
  // also sets an active class to match the active indicator on row click, and updates active top-level nav
  var rows = table 
    .selectAll("tbody")
    .data(county_data)
    .enter().append("tbody")
    .selectAll("tr")
    .data(function(d) { 
      d.values.unshift({key: d.key, values: null });
      return d.values; 
    })
    .enter().append("tr")
    .classed("active", function(d) {
      return d.key == CONFIG.active_ind.key;
    }).on("click", function(d) {
      if (d.values == null) return false; // dimension row, nothing to do
      highlight_table_row(d); // highlight the row we clicked
      highlight_nav(d);       // highlight the nav that corresponds to that row

      // and trigger an redraw for the selected variable by finding its data in the navbar
      d3.selectAll(".metric-list li.dropdown li")
      .filter(function(p) {
        return p.key == d.key
      })
      // calls the function passing in the current selection
      .call(function(p) {
        redraw(p.data()[0]);
        d3.event.stopPropagation();
      });
    }); 

  // Construct the row cells: Left-most cell with indicator or dimension name
  rows.append("td")
    .attr("class", function(d) {
      var cell_class = d.values == null ? "dimension" : "indicator";
      return cell_class;
    })
    // indicator label rows get a colspan="3", other rows do not
    .attr("colspan", function(d) { return d.values == null ? "3" : "" })
    .html(function(d) {
      var text = LOOKUP[d.key]["short_title"];
      // dimensions only get the short_title, others get additional "basetext"
      if (d.values != null) text += "<br><span class='basetext'>" + LOOKUP[d.key]["long_title"] + "<span>";
      return text;
  });

  // Construct the row cells: second column: value
  rows.append("td")
  .attr("class", function(d) {
    return d3.select(this.previousSibling).attr("class");
  })
  .html(function(d) {
    if (d.values == null) return;
    var value;
    // catch cases where rank is 0 
    if (d.values[0].rank == 0) {
      value = "NA"
    } else {
      value = d.values[0].formatted;
    }
    if (d.values[0].unreliable) value += " *";
    // additional MOE detail only goes on indicators
    if (this.classList.contains('indicator')) {
      // append MOE (cilow - cihigh), or special MOE text in MOE detail column
      if (d.values[0].moe == "undefined") return;
      var moe_text = d.values[0].moe ? `(${LOOKUP[d.values[0].moe].short_title})` : `(${d.values[0].cilow_formatted} - ${d.values[0].cihigh_formatted})`;
      value += "<br><span class='basetext_light'>" + moe_text + "</span>";
    }
    return value;
  });

  // Construct the row cells: third column: statewide value
  rows.append("td")
  .attr("class", function(d) {
    return d3.select(this.previousSibling).attr("class");
  })
  .html(function(d) {
    if (d.values == null) return;
    if (! d.values[0].state_value ) return "Not Provided";
    return d.values[0].state_value["formatted"];
  });
};

// hide the county table
function hide_county_table() {
  d3.select(".county-table")
    .style("display", "none");
  
  // revert to a three-column layout
  $('div#map-wrapper').removeClass('col-lg-8').addClass('col-lg-4');
  $('div#ethnicity-outer').css("position", "static").css("left", "auto");

  // show the notes-sources div
  $('div#notes-wrapper').show();
};

// highlight selected table row, whether clicked or selected through nav
function highlight_table_row(d) {
  d3.selectAll("table.county-table tr")
  .classed("active", function(p) {
    if (typeof p == "undefined") return false; // header row
    // because d.key="" of dimensions then using key alone will match all dimension rows
    return (d.values[0].dimension === p.values[0].dimension && d.values[0].indicator === p.values[0].indicator)
  });
}

// update top level nav so that it shows as selected
function highlight_nav(d) {
  d3.selectAll("li.dropdown")
  .classed("selected", function(p) {
    // lookup the dimension, and return true (add class="selected") if that matches the p.key (top nav is dimension)
    return (d.values[0].dimension === p.key)
  });
}

// unselect all top-level nav
function clear_nav() {
  d3.selectAll("li.dropdown")
    .classed("selected", false);
}

// bundles a few repeated reset functions
function reset_viz() {
  hide_tooltip();
  deselect_county();
  deselect_county_bar();
  CONFIG.selected_place = null;
}

// highlight selected table row, whether clicked or selected through nav
function highlight_table_row(d) {
  d3.selectAll("table.county-table tr")
  .classed("active", function(p) {
    if (typeof p == "undefined") return false; // header row
    if (p.values == null) return false; // dimension row
    return (d.values[0].indicator === p.values[0].indicator)
  });
}


function getCircleWithSlash(cx, cy, r) {
  let circlepart = "M" + cx + "," + cy + "m" + (-r) + ",0a" + r + "," + r + " 0 1,0 " + (r * 2) + ",0a" + r + "," + r + " 0 1,0 " + (-r * 2) + ",0"
  let short_r = r - 2;
  let slashpart = "M" + cx + "," + cy + "m " + short_r * -1 + "," + short_r * -1 + "l " + short_r * 2 + "," + short_r * 2;
  return circlepart + slashpart;
}

//////////////////////////////////////////////////////////
// Shims and utilities
//////////////////////////////////////////////////////////

// indicates we are on a mobile, i.e. narrow device 
function isMobile() {
  return $(window).width() < 415;
} 

// value that indicates whether we are likely being viewed on a touch device
function isTouch() {
  return !!("ontouchstart" in window) || window.navigator.msMaxTouchPoints > 0;
}

// detect iPad
function isIpad() {
  return (navigator.userAgent.match(/iPad/i)) && (navigator.userAgent.match(/iPad/i)!= null);
}

// browser sniff for Edge
var EDGE = function() {
  var ua = window.navigator.userAgent;
  var edge = ua.indexOf('Edge/');
  // is edge
  if (edge > 0) {
  // Edge (IE 12+) => return version number
  return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // not edge
  return false;
}();

// https://davidwalsh.name/javascript-debounce-function
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

// https://stackoverflow.com/a/49634926
function linkify(inputText) {
  var replacedText, replacePattern1, replacePattern2;

  //URLs starting with http://, https://, or ftp://
  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

  return replacedText;
}



// WEBPACK FOOTER //
// ./index.js